import Cookies from 'js-cookie';

import { config } from '../config';

interface ICookieOptions {
    expires?: Date | number;
    domain?: string;
}

const buildCookieKey = (key: string): string => `ST-${config.environment}_${key}`;

export const getCookie = <T = unknown>(key: string): T | null => {
    const cookie: string | undefined = Cookies.get(buildCookieKey(key));

    return typeof cookie === 'undefined'
        ? null
        : JSON.parse(cookie) as T;
};

export const setCookie = (key: string, value: string | object, expires: Date | number, isCrossDomain = false): void => {
    const options: ICookieOptions = {
        expires,
    };

    if (isCrossDomain) {
        options.domain = config.sharedCookiesDomain;
    }

    Cookies.set(
        buildCookieKey(key),
        JSON.stringify(value),
        options,
    );
};

export const setCookieCrossDomain = (key: string, value: string | object, expires: Date | number): void => {
    setCookie(key, value, expires, true);
};

export const removeCookie = (key: string, isCrossDomain = false): void => {
    const options: ICookieOptions = { };

    if (isCrossDomain) {
        options.domain = config.sharedCookiesDomain;
    }

    Cookies.remove(buildCookieKey(key), options);
};

export const removeCookieCrossDomain = (key: string): void => {
    removeCookie(key, true);
};
